// extracted by mini-css-extract-plugin
export default {"exponentsRankings":"Z_qW0gqYuApJLKNbiuaw","inlineTab":"B2Zo8Y63akJKMZD5hGMW"};